<template>
  <div>
    <transition enter-active-class="animated slideInRight" leave-active-class>
      <div class="editarDicom" v-if="mostrar">
        <AppFormCabecalho titulo="Encaminhar Estudo" icon="mdi mdi-file-export-outline" />
        <div class="editarDicom__conteudo">
          <div>
            <div class="info-estudo">
              <div>
                <div class="info-estudo__item">
                  <div class="info-estudo__item-label">Paciente ID</div>
                  <div class="info-estudo__item-value">{{ estudo.pacienteID }}</div>
                </div>
                <div class="info-estudo__item">
                  <div class="info-estudo__item-label">Paciente</div>
                  <div class="info-estudo__item-value">{{ estudo.nomePaciente }}</div>
                </div>
                <div class="info-estudo__item">
                  <div class="info-estudo__item-label">Dt. Nascimento - Sexo</div>
                  <div
                    class="info-estudo__item-value"
                  >{{ estudo.dataNascimento }} - {{ estudo.sexo }}</div>
                </div>
              </div>

              <div>
                <div class="info-estudo__item">
                  <div class="info-estudo__item-label">Estudo Instancia UID</div>
                  <div class="info-estudo__item-value">{{ estudo.estudoInstanciaUID }}</div>
                </div>
                <div class="info-estudo__item">
                  <div class="info-estudo__item-label">Descricao</div>
                  <div class="info-estudo__item-value">{{ estudo.descricao }}</div>
                </div>
                <div class="info-estudo__item">
                  <div class="info-estudo__item-label">Dt. Estudo</div>
                  <div class="info-estudo__item-value">{{ estudo.dataHoraEstudo }}</div>
                </div>
                <div class="info-estudo__item">
                  <div class="info-estudo__item-label">Modalidade</div>
                  <div class="info-estudo__item-value">{{ estudo.modalidade[0] }}</div>
                </div>
                <div class="info-estudo__item">
                  <div class="info-estudo__item-label">Total Series</div>
                  <div class="info-estudo__item-value">{{ estudo.totalSerie }}</div>
                </div>
                <div class="info-estudo__item">
                  <div class="info-estudo__item-label">Total Imagens</div>
                  <div class="info-estudo__item-value">{{ estudo.totalImagem }}</div>
                </div>
              </div>
            </div>
            <div
              class="mt-2 d-flex flex-column align-items-center"
              v-if="temDispositivos && !novoDispositivo"
            >
              <b-form-group
                label="Selecionar Dispositivo"
                label-for="dispositivo"
                class="col col-lg-4"
              >
                <b-form-select v-model="dispositivoSelecionado" size="sm" id="dispositivo">
                  <option
                    v-for="dispositivo in dispositivos"
                    :key="dispositivo.id"
                    :value="dispositivo.id"
                  >{{ dispositivo.aet }}</option>
                </b-form-select>
              </b-form-group>
              <div class="mb-3">ou</div>
              <b-button variant="outline-secondary" @click="novoDispositivo = true">
                <i class="mdi mdi-server"></i> Informar Dispositivo
              </b-button>
            </div>
            <div v-else>
              <div class="mb-2 font-weight-bold">
                <i class="mdi mdi-server"></i> Dispositivo para Encaminhar
              </div>
              <b-form-group label="AET" label-for="aet">
                <b-form-input
                  type="text"
                  id="aet"
                  class="col col-lg-6"
                  v-model="dispositivo.aet"
                  size="sm"
                  autocomplete="off"
                  :state="!$v.dispositivo.aet.$error"
                ></b-form-input>
                <b-form-invalid-feedback>Este Campo &eacute; requerido.</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Endereço" label-for="endereco">
                <b-form-input
                  type="text"
                  id="endereco"
                  class="col col-lg-6"
                  v-model="dispositivo.endereco"
                  size="sm"
                  autocomplete="off"
                  :state="!$v.dispositivo.endereco.$error"
                ></b-form-input>
                <b-form-invalid-feedback>Este Campo &eacute; requerido.</b-form-invalid-feedback>
              </b-form-group>

              <b-form-group label="Porta" label-for="porta">
                <b-form-input
                  type="text"
                  id="porta"
                  class="col col-lg-4"
                  v-model="dispositivo.porta"
                  size="sm"
                  autocomplete="off"
                  :state="!$v.dispositivo.porta.$error"
                ></b-form-input>
                <b-form-invalid-feedback>Este Campo &eacute; requerido.</b-form-invalid-feedback>
              </b-form-group>
              <b-button
                variant="link"
                @click="novoDispositivo = false"
                v-if="temDispositivos"
              >Voltar</b-button>
            </div>
          </div>
        </div>
        <div class="editarDicom__footer">
          <button class="btn btn-sm btn-default" @click="fecharForm()">Cancelar</button>
          <button
            class="btn btn-sm btn-success float-lg-right"
            @click="encaminharEstudo()"
            :disabled="encaminhando"
          >
            <i
              class="mdi"
              :class="{
                'mdi-spin mdi-loading': encaminhando,
                'mdi-check-circle': !encaminhando
              }"
            ></i>
            Encaminhar Estudo
          </button>
        </div>
      </div>
    </transition>
    <div class="editarDicom__backdrop" v-if="mostrar"></div>
  </div>
</template>
<script>
import { required } from "vuelidate/lib/validators";
import DatePicker from "vue2-datepicker";
import EstudoApi from "../../api/estudoApi";
import ServidorApi from "../../api/servidorApi";
import dispositivoFactory from "../../utils/dispositivoFactory";

import AppFormCabecalho from "../layout/AppFormCabecalho.vue";

const dispositivoData = dispositivoFactory();

export default {
  name: "encaminharEstudoForm",
  components: { AppFormCabecalho, DatePicker },
  model: {
    prop: "mostrarForm",
    event: "change"
  },
  props: {
    mostrarForm: {
      type: Boolean,
      required: true,
      default: false
    },
    estudo: {
      type: Object
    }
  },
  data() {
    return {
      mostrar: false,
      encaminhando: false,
      estudoEdit: {},
      dispositivoSelecionado: null,
      dispositivo: dispositivoData,
      dispositivos: [],
      carregandoDispositivo: false,
      novoDispositivo: false
    };
  },
  computed: {
    temDispositivos() {
      return this.dispositivos.length > 0;
    }
  },
  validations: {
    dispositivo: {
      aet: { required },
      endereco: { required },
      porta: { required }
    }
  },
  watch: {
    mostrarForm(newVal, oldVal) {
      if (newVal === oldVal) {
        return;
      }
      this.mostrar = newVal;
      //Remove rolagem do body
      document.body.style.overflow = this.mostrar ? "hidden" : "";
      if (newVal) {
        this.estudoEdit = { ...this.estudo };
        this.getDispositivos(this.estudoEdit.servidorId);
      }
    }
  },
  methods: {
    getDispositivos(servidorId) {
      this.carregandoDispositivo = true;
      ServidorApi.dispositivos(servidorId)
        .then(resp => {
          this.dispositivos = resp;
          if (this.temDispositivos) {
            this.dispositivoSelecionado = this.dispositivos[0].id;
          }
          this.carregandoDispositivo = false;
        })
        .catch(e => {
          console.log(e);
          this.carregandoDispositivo = false;
        });
    },
    fecharForm() {
      this.mostrar = false;
      this.novoDispositivo = false;
      this.$emit("change", false);
      this.dispositivoSelecionado = null;
      this.dispositivo = dispositivoFactory();
    },
    escapeKeyListener(evt) {
      if (evt.keyCode === 27 && this.mostrar) {
        this.fecharForm();
      }
    },
    encaminharEstudo() {
      if (this.novoDispositivo) {
        this.$v.$touch();
        if (this.$v.$invalid) {
          console.info("Invalido");
          return;
        }
      }

      this.encaminhando = true;
      let dispositivo = this.dispositivo;
      if (this.dispositivoSelecionado !== null && !this.novoDispositivo) {
        dispositivo = this.dispositivos.find(
          d => d.id === this.dispositivoSelecionado
        );
      }
      EstudoApi.encaminhar(
        this.estudoEdit.estudoInstanciaUID,
        this.estudoEdit.servidorId,
        dispositivo.aet,
        dispositivo.endereco,
        dispositivo.porta,
        dispositivo.retrieveSemCompressao
      )
        .then(() => {
          if (this.novoDispositivo) {
            this.$swal({
              title: "Deseja salvar o novo dispositivo?",
              html:
                "O estudo foi encaminhado para um novo dispositivo. Deseja salvar o dispositivo no servidor do estudo?<br/>Será possível editar ou remover o dispositivo no cadastro do servidor.",
              type: "warning",
              showCancelButton: true,
              confirmButtonClass: "btn btn-outline-success",
              cancelButtonClass: "btn btn-outline-secondary mr-3",
              buttonsStyling: false,
              confirmButtonText: "Não salvar dispositivo",
              cancelButtonText: "Sim, salvar o disposito!",
              reverseButtons: true,
              focusCancel: false,
              focusConfirm: true
            }).then(resp => {
              if (!resp.value) {
                ServidorApi.salvarDispositivo(
                  this.estudoEdit.servidorId,
                  dispositivo
                )
                  .then(() => {})
                  .catch(() => {});
              }
            });
          }
          this.encaminhando = false;
          this.fecharForm();
        })
        .catch(() => {
          this.encaminhando = false;
        });
    }
  },
  created() {
    document.addEventListener("keyup", this.escapeKeyListener);
  },
  destroyed() {
    document.removeEventListener("keyup", this.escapeKeyListener);
  }
};
</script>
<style lang="scss" scoped>
.animated.slideInRight,
.animated.slideOutRight {
  animation-duration: 0.5s;
}
.editarDicom {
  position: fixed;
  width: 50%;
  top: 41px;
  bottom: 0;
  right: 0;
  background-color: #fff;
  z-index: 1041;
  border-left: 1px solid #e3e3e3;
  display: flex;
  flex-direction: column;
  flex: 0;
  .wbs-form-header {
    padding: 10px 10px 0 10px;
  }
  @include element("conteudo") {
    padding: 10px;
    flex: 1;
  }
  @include element("footer") {
    padding: 10px;
    flex: 0;
    border-top: 1px solid #e3e3e3;
  }
}
.editarDicom__backdrop {
  opacity: 0.5;
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 1040;
  background-color: #000;
}

.info-estudo {
  padding-bottom: 15px;
  margin-bottom: 15px;
  border-bottom: 1px solid #e3e3e3;

  .info-estudo__item {
    display: flex;
    margin-bottom: 3px;
  }

  .info-estudo__item-label {
    flex: 1;
    font-weight: bold;
  }

  .info-estudo__item-value {
    flex: 2;
  }
}
</style>
